import { useCallback, useMemo } from 'react'
import { useSelector } from 'react-redux'
import { dispatch } from 'store'
import { aiAvatarSelectors } from 'store/features/aiAvatar/selectors'
import { aiAvatarThunks } from 'store/features/aiAvatar/thunks'
import { userSelectors } from 'store/features/user/selectors'
import { MIN_PREMIUM_QUALITY } from 'consts'
import { REF_LINKS } from 'consts/refLinks'
import { QUALITY_LABELS } from './consts'
import { useOpenUpgradePopup } from 'hooks/useOpenUpgradePopup'

export const useAvatarQuality = () => {
  const quality = useSelector(aiAvatarSelectors.quality)
  const possibleQualities = useSelector(
    aiAvatarSelectors.avatarPossibleQualities
  )
  const isFreeUser = useSelector(userSelectors.isFreeUser)
  const openUpgradePopup = useOpenUpgradePopup()

  const options = useMemo(
    () =>
      possibleQualities.map(value => ({
        value,
        label: QUALITY_LABELS[value] ?? `${value}p`,
        isPremium: isFreeUser && value >= MIN_PREMIUM_QUALITY
      })),
    [possibleQualities, isFreeUser]
  )

  // Free users can't pick a premium quality — surface the upgrade popup and
  // leave the current selection untouched (mirrors the AI Video quality gate).
  const onSelect = useCallback(
    (value: number) => {
      if (isFreeUser && value >= MIN_PREMIUM_QUALITY) {
        openUpgradePopup({
          ref: REF_LINKS.V_EDITOR_AVATAR_UPGRADE_FOR_HIGHER_QUALITY
        })
        return
      }

      dispatch(aiAvatarThunks.setQuality(value))
    },
    [isFreeUser, openUpgradePopup]
  )

  return { quality, options, onSelect }
}
